import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GameLayout from "../../components/game/GameLayout";
import ResultScreen from "../../components/game/ResultScreen";

function computeFeedback(percentage) {
  if (percentage >= 85) return "Excellent lifestyle awareness. Keep this momentum.";
  if (percentage >= 60) return "Good progress. Small daily habits can further improve your score.";
  return "Start with one healthier habit this week and retake the game.";
}

export default function ResultPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state || {};

  const score = Number(state.score || 0);
  const totalQuestions = Number(state.totalQuestions || 0);
  const pointsPerCorrect = Number(state.pointsPerCorrect || 10);
  const passScorePercent = Number(state.passScorePercent || 60);
  const elapsedSeconds = Number(state.elapsedSeconds || 0);
  const completed = state.completed || {};
  const percentage = useMemo(() => {
    if (!totalQuestions || !pointsPerCorrect) return 0;
    return Math.round((score / (totalQuestions * pointsPerCorrect)) * 100);
  }, [score, totalQuestions, pointsPerCorrect]);

  const passed = percentage >= passScorePercent;
  const elapsedLabel = `${String(Math.floor(elapsedSeconds / 60)).padStart(2, "0")}:${String(
    elapsedSeconds % 60
  ).padStart(2, "0")}`;

  return (
    <GameLayout title="Game Result" subtitle="Your static React game summary">
      <ResultScreen
        score={score}
        totalQuestions={totalQuestions}
        pointsPerCorrect={pointsPerCorrect}
        percentage={percentage}
        passed={passed}
        feedback={computeFeedback(percentage)}
        ctaLabel="Restart Game"
        onRestart={() => navigate("/game", { replace: true })}
      >
        <p className="result-feedback">Total Time: {elapsedLabel}</p>
        {Object.keys(completed).length > 0 ? (
          <p className="result-feedback">
            Stage Scores:{" "}
            {Object.entries(completed)
              .map(([id, val]) => `${id} ${val.score}/${val.max}`)
              .join(" | ")}
          </p>
        ) : null}
      </ResultScreen>
    </GameLayout>
  );
}
